<template>
  <div>
    <div
      class="flex-grow flex flex-col m-2 p-6 bg-white border-t border-b sm:rounded sm:border shadow overflow-hidden"
    >
      <div class="flex flex-wrap items-center">
        <div class="relative w-full px-4 max-w-full flex-grow flex-1">
          <h3 class="font-semibold text-base text-gray-800">
            {{ title }}
          </h3>
        </div>
      </div>
      <div class="flex flex-wrap items-center mt-5">
        <div
          class="relative w-full px-4 max-w-full flex-grow flex-1 text-right"
        >
          <div
            class="border hover:border-green-500  w-full focus-within:border-blue-500 focus-within:text-green-500  transition-all duration-500 relative rounded p-1"
          >
            <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
              <p>
                <label for="status" class="bg-white text-gray-700 px-1"
                  >Date : <span :class="$colors.required">*</span></label
                >
              </p>
            </div>
            <p>
              <select
                id="type"
                autocomplete="type"
                @change="ChangeTypeDateAllSeller($event)"
                v-model="timeserchtype"
                class="py-2 text-xs capitalize px-2 outline-none block h-full w-full bg-white"
              >
                >
              <option class="bg-white text-gray-600" value="today">
                  Today
                </option>
                <option class="bg-white text-gray-600" value="thisweek">
                  This Week
                </option>
                <option class="bg-white text-gray-600" value="lastweek">
                  Last Week
                </option>
                <option class="bg-white text-gray-600" value="thismonth">
                  This Month
                </option>
                <option class="bg-white text-gray-600" value="lastmonth">
                  Last Month
                </option>
                <option class="bg-white text-gray-600" value="thisyear">
                  This Year
                </option>
                <option value="betweendate" class="bg-white text-gray-600"> Between two date </option>
              </select>
            </p>
          </div>
        </div>
         <div v-if="filter && timeserchtype=='betweendate'" class="relative w-full px-2 max-w-full flex-grow flex-1 text-right">
          <div  class="inline-block">
              <div class="inline-block w-2/5 pr-1">
                <div class="border hover:border-blue-400 w-full focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                  <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs"><p><label for="date" class="bg-white text-gray-700 px-1">From <span class="text-blue-500">*</span></label></p></div>
                    <p>  <input  v-model="fromDate" class="w-full px-1 py-1 text-gray-700 bg-gray-200 rounded" id="from" type="date"> </p>
                </div>
              </div>
                <div class="inline-block  w-2/5 pr-1">
                  <div class="border hover:border-blue-400 w-full focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                  <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs"><p><label for="date" class="bg-white text-gray-700 px-1">To <span class="text-blue-500">*</span></label></p></div>
                    <p>  <input  v-model="toDate" class="w-full px-1 py-1 text-gray-700 bg-gray-200 rounded" id="to" type="date"> </p>
                </div>
              </div>
              <div class="inline-block  w-1/5 pr-1">
                  <button @click="FindRecordSellers()"  :disabled="fromDate==null || toDate==null" class="w-full px-2 py-2 text-white font-light tracking-wider bg-gray-900 rounded">Find</button>
              </div>
          </div>
        </div>
      </div>
      <canvas :id="id" style="height: 300px"></canvas>
    </div>
  </div>
</template>



<script>
import Chart from "chart.js";
//import ChartDataLabels from "chartjs-plugin-datalabels";
export default {
  props: [
    "chartData",
    "options",
    "Labels",
    "labelstring",
    "timeserch",
    "id",
    "title",
    "type",
    "userType",
    "filter",
    "count",
    "from",
    "to"
  ],
  data() {
    return {
      myChart: "",
      timeserchtype: this.timeserch,
      fromDate:this.from,
      toDate:this.to,
    };
  },
  async mounted() {
    await this.drawChart(this.chartData);
  },
  methods: {
    FindRecordSellers: function () {
      this.$emit("FindRecordSellers",this.fromDate,this.toDate);
    },
    ChangeTypeDateAllSeller: function (val) {
      this.$emit("ChangeTypeDateAllSeller", val);
    },

    drawChart(chartData) {
      var ctx = document.getElementById(this.id);
      this.myChart = new Chart(ctx, {
        type: "doughnut",

        showTooltips: true,
        data: {
          labels: ["blocked ("+this.chartData[0]+')', "active ("+this.chartData[1]+')',"inactive ("+this.chartData[2]+')', "deleted ("+this.chartData[3]+')'],
          datasets: [
            {
              label: "Total Orders",
              data: chartData,
              backgroundColor: ["#ff6384", "#79D1CF", "rgb(154,205,50)","#ffce56"],
              borderColor: ["#ff6384", "#79D1CF", "rgb(154,205,50)","#ffce56"],
              borderWidth: 1,
              weight: 2,
            },
          ],
        },
      options: {
          responsive: true,
          tooltips: {
            callbacks: {
                label: function(tooltipItem, data) {
                  var allData = data.datasets[tooltipItem.datasetIndex].data;
                  var tooltipLabel = data.labels[tooltipItem.index];
                  var tooltipData = allData[tooltipItem.index];
                  var total = 0;
                  for (var i in allData) {
                    total += allData[i];
                  }
                  var tooltipPercentage = Math.round((tooltipData / total) * 100);
                  return tooltipLabel + ': ' + tooltipData + ' (' + tooltipPercentage + '%)';
                }
              }
          },
           title: {
            display: true,
            text: 'Total Registrants: '+this.count,
            position: 'top',
            fontSize: 16,
            fontColor: '#111',
            padding: 20
        },
        legend: {
            display: true,
            position: 'bottom',
            labels: {
                boxWidth: 20,
                fontColor: '#111',
                padding: 15
            }
        },
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                },
              },
            ],
          },
        },
      });
    },
  },
  watch: {
    chartData: function () {
      if (this.myChart != null) {
        this.myChart.destroy();
      }
      this.drawChart(this.chartData);
    },
  },
};
</script>
<style scoped>
body {
  font-family: "IBM Plex Mono", sans-serif;
}
[x-cloak] {
  display: none;
}
.vs__dropdown-toggle {
  border: none;
}
.line {
  background: repeating-linear-gradient(
    to bottom,
    #eee,
    #eee 1px,
    #fff 1px,
    #fff 8%
  );
}
.tick {
  background: repeating-linear-gradient(
    to right,
    #eee,
    #eee 1px,
    #fff 1px,
    #fff 5%
  );
}
</style>